// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lang-wrapper {
  display: inherit;
  align-items: center;
  font-size: 16px;
  padding-right: 40px;
  color: white;
}
.lang-wrapper .lang {
  cursor: pointer;
}
.lang-wrapper .lang:first-child {
  border-right: 1px solid white;
}
.lang-wrapper .lang:last-child {
  padding-left: 5px;
}
.lang-wrapper .active {
  color: var(--vl-red);
}
.lang-wrapper.sidebar {
  color: #262626;
}
.lang-wrapper.sidebar .active {
  color: white;
}`, "",{"version":3,"sources":["webpack://./src/shared/components/elements/language-switcher/language-switcher.component.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,mBAAA;EACA,YAAA;AACF;AAAE;EACE,eAAA;AAEJ;AAAE;EACE,6BAAA;AAEJ;AAAE;EACE,iBAAA;AAEJ;AAAE;EACE,oBAAA;AAEJ;AAAE;EACE,cAAA;AAEJ;AADI;EACE,YAAA;AAGN","sourcesContent":[".lang-wrapper {\n  display: inherit;\n  align-items: center;\n  font-size: 16px;\n  padding-right: 40px;\n  color: white;\n  .lang {\n    cursor: pointer;\n  }\n  .lang:first-child {\n    border-right: 1px solid white;\n  }\n  .lang:last-child {\n    padding-left: 5px;\n  }\n  .active {\n    color: var(--vl-red);\n  }\n  &.sidebar{\n    color: #262626;\n    .active {\n      color: white;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
